import { completeRsc } from "helpers/rsc";
import { isCustomEvents } from "../../../helpers/utils";

export const subscribeUrlTabEvent = ({ params, payloadParams }) => {

  // Do nothing for no head to head disciplines
  const { isH2H } = payloadParams;
  if (!isH2H) return;

  // Select all anchor elements with the href attribute
  const allTabs = document.querySelectorAll('[role="tab"]')

  // Do nothing if there are no tabs 
  if (!(allTabs?.length > 0)) return;

  // Add listener only for statistic pages
  allTabs.forEach((tab) => {
    if (/mirs-navsport-tab-(3|4).+/.test(tab?.id)) {
      tab.addEventListener('click', (e) => { customUrlEventDispatcher({ e: e, params: params, payloadParams: payloadParams }) });
    }
  })
}

export const unSubscribeUrlTabEvent = ({ params, payloadParams }) => {

  // Do nothing for no head to head disciplines
  const { isH2H } = payloadParams;
  if (!isH2H) return;

  // Select all anchor elements with the href attribute
  const allTabs = document.querySelectorAll('[role="tab"]')

  // Do nothing if there are no tabs 
  if (!(allTabs?.length > 0)) return;

  // Add listener only for statistic pages
  allTabs.forEach((tab) => {
    if (/mirs-navsport-tab-(3|4).+/.test(tab?.id)) {
      tab.removeEventListener('click', (e) => { customUrlEventDispatcher({ e: e, params: params, payloadParams: payloadParams }) });
    }
  })
}

function ocsDelay() {
  const delayInMs = isNaN(Number(process.env.REACT_OCS_DELAY_MS)) ? 900 : Number(process.env.REACT_OCS_DELAY_MS)
  return new Promise(resolve => setTimeout(resolve, delayInMs));
}

export async function customUrlEventDispatcher({ e, params, payloadParams, disciplines, noc }) {

  await ocsDelay();

  const { mirs_rsc, mirs_discipline, mirs_event_rsc2 } = params

  const mirs_event_rsc = mirs_event_rsc2

  const { isH2H, statusCode, resultStatusCode, urlData } = payloadParams;

  const tab = e?.target?.id

  const { pageType, athleteCode, teamCode, coachCode, officialCode, horseCode, nocCode } = getPageType({ urlData: urlData, tab: tab, isH2H: isH2H })

  const { scheduleStatus } = getScheduleStatus({ statusCode: statusCode, resultStatusCode: resultStatusCode })

  const disciplineCode = Array.isArray(disciplines) && disciplines.length > 0 ? disciplines.join(',') : mirs_discipline?.length === 3 ? mirs_discipline : undefined

  let rsc
  if (mirs_rsc?.length === 34) {
    rsc = mirs_rsc
  } else if (mirs_event_rsc?.length === 22) {
    rsc = completeRsc(mirs_event_rsc)
  }

  const payload = {
    pageType: pageType,
    disciplineCode: disciplineCode,
    NOCCode: noc || nocCode,
    athleteCode: athleteCode,
    teamCode: teamCode,
    coachCode: coachCode,
    officialCode: officialCode,
    horseCode: horseCode,
    scheduleStatus: scheduleStatus
  }

  payload.RSCCode = rsc || (sessionStorage.getItem('RSC')?.length === 34 || sessionStorage.getItem('RSC')?.length === 22 ? completeRsc(sessionStorage.getItem('RSC')) : undefined)

  // filter undefined values
  const filteredPayLoad = Object.fromEntries(
    Object.entries(payload).filter(([key, value]) => value !== undefined)
  );

  const disableDispatch = (pageType === PAGE_TYPE.ATHLETE_DETAILS || pageType === PAGE_TYPE.TEAM_DETAILS || pageType === PAGE_TYPE.HORSE_DETAILS || pageType === PAGE_TYPE.COACH_DETAILS || pageType === PAGE_TYPE.OFFICIAL_DETAILS || pageType === PAGE_TYPE.NOC_DETAILS) && !Array.isArray(disciplines);

  if (isCustomEvents() || process.env.REACT_APP_DEVELOPMENT === 'DEV' || process.env.REACT_APP_DEVELOPMENT === 'MT') {
    if (!disableDispatch) {
      const event = new CustomEvent('OnContentLoad', { detail: filteredPayLoad });
      window.dispatchEvent(event)
    }
  }
}


const PAGE_TYPE = {
  ATHLETE_DETAILS: "athleteDetails",
  BRACKET: "bracket",
  COACH_DETAILS: "coachDetails",
  GROUP_STANDINGS: "groupStandings",
  HORSE_DETAILS: "horseDetails",
  NOC_DETAILS: "NOCDetails",
  NOC_LIST: "NOCList",
  OFFICIAL_DETAILS: "officialDetails",
  OTHER: "other",
  PARTICIPANT_LIST: "participantList",
  RANKING: "ranking",
  REPORTS: "officialReports",
  RECORD_DETAILS: "recordDetails",
  RECORD_LIST: "recordList",
  RESULTS: "results",
  STANDINGS: "standings",
  STATISTICS: "statistics",
  TEAM_DETAILS: "teamDetails"
}

const SCHEDULE_STATUS = {
  SCHEDULED: "scheduled",
  UNSCHEDULED: "unscheduled",
  SCHEDULED_BREAK: "scheduled-break",
  IN_PROGESS: "in-progress",
  CANCELLED: "cancelled",
  DELAYED: "delayed",
  FINISHED: "finished",
  INTERRUPTED: "interrupted",
  POSTPONED: "postponed",
  RESCHEDULED: "rescheduled",
  OFFICIAL: "official",
  PROTESTED: "protested",
  PROVISIONAL: "provisional",
  GETTING_READY: "getting-ready"
}



const getScheduleStatus = ({ statusCode, resultStatusCode }) => {
  let scheduleStatus

  if (resultStatusCode === 'OFFICIAL') {
    scheduleStatus = SCHEDULE_STATUS.OFFICIAL

  } else if (resultStatusCode === 'PROTESTED') {
    scheduleStatus = SCHEDULE_STATUS.PROTESTED

  } else if (statusCode === 'status_1') {
    scheduleStatus = SCHEDULE_STATUS.UNSCHEDULED

  } else if (statusCode === 'status_2') {
    scheduleStatus = SCHEDULE_STATUS.SCHEDULED

  } else if (statusCode === 'status_3') {
    scheduleStatus = SCHEDULE_STATUS.GETTING_READY

  } else if (statusCode === 'status_4') {
    scheduleStatus = SCHEDULE_STATUS.IN_PROGESS

  } else if (statusCode === 'status_5') {
    scheduleStatus = SCHEDULE_STATUS.FINISHED

  } else if (statusCode === 'status_6') {
    scheduleStatus = SCHEDULE_STATUS.DELAYED

  } else if (statusCode === 'status_7') {
    scheduleStatus = SCHEDULE_STATUS.INTERRUPTED

  } else if (statusCode === 'status_8') {
    scheduleStatus = SCHEDULE_STATUS.CANCELLED

  } else if (statusCode === 'status_9') {
    scheduleStatus = SCHEDULE_STATUS.SCHEDULED_BREAK

  } else if (statusCode === 'status_10') {
    scheduleStatus = SCHEDULE_STATUS.POSTPONED

  } else if (statusCode === 'status_11') {
    scheduleStatus = SCHEDULE_STATUS.RESCHEDULED

  } else {
    scheduleStatus = undefined
  }

  return ({ scheduleStatus: scheduleStatus })
}

const getPageType = ({ urlData, tab, isH2H }) => {
  let pageType
  let athleteCode
  let teamCode
  let coachCode
  let officialCode
  let horseCode
  let nocCode;

  if (/mirs-navsport-tab-(3|4).+/.test(tab)) {
    pageType = PAGE_TYPE.STATISTICS

  } else if (urlData?.isResult) {
    pageType = PAGE_TYPE.RESULTS

  } else if (urlData?.isBracket) {
    pageType = PAGE_TYPE.BRACKET

  } else if (urlData?.isPool) {
    pageType = PAGE_TYPE.GROUP_STANDINGS

  } else if (urlData?.isResult) {
    pageType = PAGE_TYPE.STATISTICS

  } else if (urlData?.isRecords) {
    pageType = PAGE_TYPE.RECORD_LIST

  } else if (urlData?.isRecords) {
    pageType = PAGE_TYPE.RECORD_DETAILS

  } else if (urlData?.isAthletes || urlData?.isHorses || urlData?.isTechnicalOfficials || urlData?.isCoaches || urlData?.isTeams) {
    pageType = PAGE_TYPE.PARTICIPANT_LIST

  } else if (urlData?.isBios) {
    athleteCode = getCompCode(urlData?.isBios?.params["*"])
    pageType = PAGE_TYPE.ATHLETE_DETAILS

  } else if (urlData?.isTeam) {
    teamCode = getCompCode(urlData?.isTeam.params["*"])
    pageType = PAGE_TYPE.TEAM_DETAILS

  } else if (urlData?.isCoach) {
    coachCode = getCompCode(urlData?.isCoach.params["*"])
    pageType = PAGE_TYPE.COACH_DETAILS

  } else if (urlData?.isOfficial) {
    officialCode = getCompCode(urlData?.isOfficial.params["*"])
    pageType = PAGE_TYPE.OFFICIAL_DETAILS

  } else if (urlData?.isHorse) {
    horseCode = getCompCode(urlData?.isHorse.params["*"])
    pageType = PAGE_TYPE.HORSE_DETAILS

  } else if (urlData?.isNocList) {
    pageType = PAGE_TYPE.NOC_LIST

  } else if (urlData?.isProfileByNoc) {
    pageType = PAGE_TYPE.NOC_DETAILS
    nocCode = urlData?.isProfileByNoc?.params["*"]

  } else if (urlData?.isRanking) {
    pageType = PAGE_TYPE.RANKING

  } else if (urlData?.isReports) {
    pageType = PAGE_TYPE.REPORTS

  } else {
    pageType = PAGE_TYPE.OTHER
  }

  return (
    {
      pageType: pageType,
      athleteCode: athleteCode,
      teamCode: teamCode,
      coachCode: coachCode,
      officialCode: officialCode,
      horseCode: horseCode,
      nocCode: nocCode
    }
  )
}


const getCompCode = (value) => {
  let out = value
  const delimiter = "_";
  if (value?.includes(delimiter)) {
    const values = value.split(delimiter);
    out = values[values.length - 1];
  }
  return out ? out?.toUpperCase() : '';
}
